import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetBrands, CreateBrand, UpdateBrand, DeleteBrand } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const brandQueryKeys = {
  brands: () => ["brands"] as const,
};

export const invalidateBrandQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["brands"] });
};

export const useBrandsQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: brandQueryKeys.brands(),
    queryFn: async () => unwrapApiResponse(await GetBrands()),
  });
};

export const useBrandsRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      queryClient.fetchQuery({
        staleTime: LOOKUP_STALE_TIME,
        queryKey: brandQueryKeys.brands(),
        queryFn: async () => unwrapApiResponse(await GetBrands()),
      }),
  });
};

export const useCreateBrandMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateBrand>[0]) =>
      CreateBrand(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateBrandQueries(queryClient);
      }
    },
  });
};

export const useUpdateBrandMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateBrand>[0]) =>
      UpdateBrand(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateBrandQueries(queryClient);
      }
    },
  });
};

export const useDeleteBrandMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof DeleteBrand>[0]) =>
      DeleteBrand(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateBrandQueries(queryClient);
      }
    },
  });
};
